import { connect } from "react-redux"
import { withNamespaces } from "react-i18next"

import LoginRegistrationWidget from "QuorumGrassroots/widgets/LoginRegistration/components/index"

import { LoginRegistationConnection } from "QuorumGrassroots/widgets/LoginRegistration/selectors"

export default withNamespaces()(connect(LoginRegistationConnection, null)(LoginRegistrationWidget))
